import { Fragment } from 'react'

// The lawyer-approved interim Terms (7 Oct 2026), shown word for word from
// src/content/termsInterim.js. "#", "##" and "###" lines become headings;
// every other line is its own paragraph. Nothing is reworded here — only
// the three links below are made clickable.
const LINKS = [
{ text: 'www.hireitnow.au/auth?mode=signup', href: 'https://www.hireitnow.au/auth?mode=signup' },
{ text: 'www.hireitnow.au/privacy', href: 'https://www.hireitnow.au/privacy' },
{ text: 'hello@hireitnow.au', href: 'mailto:hello@hireitnow.au' },
]
const LINK_RE = new RegExp(`(${LINKS.map(l => l.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g')

// Splits a line into plain text and links. Keeps every character.
export function withLinks(line) {
return line.split(LINK_RE).map((part, i) => {
const link = LINKS.find(l => l.text === part)
return link
? <a key={i} href={link.href} style={{ color: 'var(--primary)', overflowWrap: 'anywhere' }}>{part}</a>
: <Fragment key={i}>{part}</Fragment>
})
}

// "## 1. Definitions" → { type: 'h2', text: '1. Definitions' }; plain lines → 'p'
export function parseTerms(md) {
return md.split('\n').filter(line => line.trim() !== '').map(line => {
const m = line.match(/^(#{1,3}) (.*)$/)
return m ? { type: `h${m[1].length}`, text: m[2] } : { type: 'p', text: line }
})
}
